import { pgEnumFromObject } from "../../../functions/pgEnumFromObject";
import { CONSULTATION_STATUS } from "../constants/CONSULTATION_STATUS";

/**
 * @group Enums
@summary
<blockquote>PostgreSQL enum for consultation status values used in patient telehealth sessions</blockquote>
 * @internal
 */
export const consultationStatusEnum = pgEnumFromObject('consultation_status', 
  Object.fromEntries(Object.values(CONSULTATION_STATUS).map(value => [value, value]))
);
